import CardActionArea from '@mui/material/CardActionArea';
import { makeStyles } from 'tss-react/mui';
import Typography from '@mui/material/Typography';
import ArrowRightIcon from '@mui/icons-material/ArrowForward';
import React from 'react';
import { slugFromCC } from 'tf-post-parser';
import imageCrop from 'helpers/imageCrop';
import shadow from '../../helpers/shadow';
import Link from '@mui/material/Link';
import Excerpt from '../Grid/Excerpt';
import Image from 'components/Image';
import LinkWrapper from './LinkWrapper';

export default function CarouselItem({ post, isLastItem, moreHref }) {
  const { thumb, title } = post;

  const useStyles = makeStyles()(() => ({
    imgContainer: {
      borderRadius: 8,
      height: '220px',
      width: '100%',
      overflow: 'hidden',
      position: 'relative',
      boxShadow: shadow.md,
    },
    arrowFont: {
      fontSize: 80,
    },
  }));

  const { classes } = useStyles();

  let linkAs = isLastItem
    ? undefined
    : `/@${post.author.username}/${post.permlink}`;
  if (isLastItem) {
    linkAs = moreHref;
    if (!moreHref) {
      linkAs = `/destinations/${
        post && post.location && post.location.countryCode
          ? slugFromCC(post.location.countryCode)
          : ''
      }`;
    }
  }

  return (
    <div className="w-100">
      <LinkWrapper linkHref={linkAs}>
        <div
          key={post.permlink}
          className="w-100"
          style={{ maxHeight: '340px' }}
        >
          <div className={classes.imgContainer}>
            <CardActionArea>
              {thumb && thumb.url && (
                <>
                  <div className="tw-z-10 tw-w-full tw-h-56 tw-relative tw-shrink-0 tw-transition-all tw-duration-500 hover:tw-scale-110">
                    {isLastItem && (
                      <div className="tw-flex tw-absolute tw-z-20 tw-h-56 tw-w-full tw-bg-black/50">
                        <div
                          className={`tw-m-auto text-light ${classes.arrowFont}`}
                        >
                          <ArrowRightIcon fontSize="inherit" />
                        </div>
                      </div>
                    )}
                    <Image
                      unoptimized
                      src={imageCrop(thumb.url, 612, 420)}
                      layout="fill"
                      alt={title}
                      blurDataURL={thumb.blur}
                      placeholder={thumb.blur ? 'blur' : undefined}
                      objectFit="cover"
                    />
                  </div>
                </>
              )}
            </CardActionArea>
          </div>
          {isLastItem ? (
            <>
              <div className="mt-2" />
              <Typography
                color="textPrimary"
                gutterBottom
                variant="h6"
                component="h2"
                className="preview-title"
              >
                View more
              </Typography>
            </>
          ) : (
            <>
              <div className="mt-2" />
              <Excerpt title={post.title} />
              <Link color="textPrimary" href={`/@${post.author.username}`}>
                <Typography color="primary" className="font-weight-bold">
                  by {post.author.displayName}
                </Typography>
              </Link>
            </>
          )}
        </div>
      </LinkWrapper>
    </div>
  );
}
